module.exports = __webpack_public_path__ + "img/footer_work_house.5828711.svg?v=1762502055057";